import getProvider from "./rpcProviderService";

const getWallet = async () => {
    let provider;
    let signer;
    let isReadOnly = true;
    let isWrongNetwork = false;
    if (window.ethereum) {
        try {
            provider = getProvider(false);
            await provider.send("eth_requestAccounts", []);
            signer = provider.getSigner();
            isReadOnly = false;
        } catch (error) {
            console.log("JsonRPC");
            provider = getProvider(true);
        }
    } else {
        console.log("JsonRPC");
        provider = getProvider(true);
    }
    // isWrongNetwork = (await provider.getNetwork()).name == 'matic' ? false : true;
    // const maxFeePerGas = (await getGasPrice()).toFixed(2);
    isWrongNetwork = {}
    const maxFeePerGas = {}
    return { provider, signer, isReadOnly, isWrongNetwork, maxFeePerGas };
}

const getGasPrice = async () => {
    try {
        const response = await fetch('https://gasstation-mainnet.matic.network/v2');
        // const response = await fetch('https://gasstation-mumbai.matic.today/v2');
        const json = await response.json();

        const maxPriorityFee = json.standard.maxPriorityFee
        return maxPriorityFee
    } catch (error) {
        return 0;
    }
}

export default getWallet;